export enum BroadcastKey {
	system_alert_new = 'system_alert_new',
	system_alert_cancelled = 'system_alert_cancelled',
	termsUpdated = 'termsUpdated'
}
